import { apiURL, encryptionKey, insightsURL, bChatURL, bIntegrationsURL, merakiUrl, airshipUrl, metaUrl, unifiUrl, tplinkUrl, brevoUrl,
  atreemoUrl, klaviyoUrl, googleAdsUrl, comoUrl, reviewsUrl, stripePublishableKey, bMarketingUrl, bSurveysUrl, dotdigitalUrl, leatUrl, sevenroomsUrl, brazeUrl, bloomreachUrl, eatAppUrl, mcpUrl } from "../helpers/config";

const params = {
  apiUrl: apiURL,
  insightsUrl: insightsURL,
  bChatUrl: bChatURL,
  bIntegrationsUrl: bIntegrationsURL,
  encryptionKey: encryptionKey,
  merakiUrl: merakiUrl,
  airshipUrl: airshipUrl,
  unifiUrl: unifiUrl,
  tplinkUrl: tplinkUrl,
  metaUrl: metaUrl,
  atreemoUrl: atreemoUrl,
  brevoUrl: brevoUrl,
  klaviyoUrl: klaviyoUrl,
  comoUrl: comoUrl,
  googleAdsUrl: googleAdsUrl,
  reviewsUrl: reviewsUrl,
  stripePublishableKey: stripePublishableKey,
  bMarketingUrl: bMarketingUrl,
  bSurveysUrl: bSurveysUrl,
  dotdigitalUrl: dotdigitalUrl,
  leatUrl: leatUrl,
  sevenroomsUrl: sevenroomsUrl,
  brazeUrl: brazeUrl,
  bloomreachUrl: bloomreachUrl,
  eatAppUrl: eatAppUrl,
  mcpUrl: mcpUrl,
};

export default params;
